import { Grid } from "@mui/material";
import { Button, styled } from "@mui/material";

interface ActionButtonsProps {
  resetErrorBoundary: () => void;
}

function clickWhatsApp() {
  window.open("https://wa.me/+18093304948", "_blank");
}

export function ErrorFallbackActionButtons({
  resetErrorBoundary
}: ActionButtonsProps) {
  return (
    <Grid container item xs={12} justifyContent="center" gap={0.6}>
      <StyledButton onClick={resetErrorBoundary}>Intente otra vez</StyledButton>
      <StyledButtonWS onClick={clickWhatsApp}>Mesa de ayuda</StyledButtonWS>
    </Grid>
  );
}

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "1.3rem",
  marginBottom: "1.2rem",
  textTransform: "none",
  fontWeight: 400,
  color: "#fff",
  backgroundColor: "#1a3668",
  padding: "0.3rem 1.2rem",
  borderRadius: "1.8rem",
  fontSize: "1rem",

  "&:hover": {
    backgroundColor: "#071326"
  }
}));

const StyledButtonWS = styled(Button)(({ theme }) => ({
  marginTop: "1.3rem",
  marginBottom: "1.2rem",
  textTransform: "none",
  fontWeight: 400,
  backgroundColor: "#19c558",
  color: "#fff",
  padding: "0.3rem 1.2rem",
  borderRadius: "1.8rem",
  fontSize: "1rem",

  "&:hover": {
    backgroundColor: "#1a994a"
  }
}));
